import { FC } from "react";

import { PrescriberInfoProps } from "./types";
import { CASE_CATEGORY } from "src/constants/cases";
import { getQtyLabel } from "src/constants/packOptions";
import { format } from 'date-fns';


const ShowPrescriberInformation: FC<PrescriberInfoProps> = ({ getValues }): JSX.Element => {
  const { prescription_attributes, category ,prescription_information_attributes} = getValues();

  return (
    <div className="card my-3">
      <div className="card-header">
        <h1 className="m-0">Prescription Information</h1>
      </div>
      <div className="card-body">
        <div className="row p-2">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Benefits being requested:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{category ? CASE_CATEGORY[category as ("rx" | "med" | "medrx")] : "N/A"}</p>
              </div>
            </div>
          </div>
          <div>

          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Patient Diagnosis:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.condition ? prescription_attributes.condition  : 'N/A'}</p>
              </div>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Diagnosis Code (ICD):</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes?.diagnosis_code?.length > 0  ? prescription_attributes.diagnosis_code.join(", ") : 'N/A'}</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Package Size:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.packaging_size ? prescription_attributes.packaging_size : 'N/A'}</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Quantity & Cartridges Per Box:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.qty ? getQtyLabel(prescription_attributes.packaging_size, prescription_attributes.qty) : 'N/A'}</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Inhale Unit per meal:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_information_attributes && prescription_information_attributes.inhale_units ? prescription_information_attributes.inhale_units : 'N/A'}</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Use additional unit as needed:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_information_attributes && prescription_information_attributes.additional_units ? prescription_information_attributes.additional_units : 'N/A'}</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Max Daily Dose:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_information_attributes && prescription_information_attributes.total_daily_units ? prescription_information_attributes.total_daily_units : 'N/A'}</p>
              </div>
            </div>
          </div>
           <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3"># of Refills:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_information_attributes && prescription_information_attributes.refills ? prescription_information_attributes.refills : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Anticipated Date of Service:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.scheduled_date_of_service ? format(new Date(prescription_attributes.scheduled_date_of_service), 'MM/dd/yyyy') : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Notes:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.note ? prescription_attributes.note : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Written Date:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.written_date ? prescription_attributes.written_date : 'N/A'}</p>
              </div>
            </div>
          </div>
          {/* <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Patient Training Required:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.Patient_training_required ? 'Yes' : 'No'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Target After Meal Blood Glucose Min:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.targetAfterMealBloodGlucoseMin ? prescription_attributes.targetAfterMealBloodGlucoseMin : 'N/A'}</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3">Target After Meal Blood Glucose Max:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.targetAfterMealBloodGlucoseMax ? prescription_attributes.targetAfterMealBloodGlucoseMax : 'N/A'}</p>
              </div>
            </div>
          </div> */}
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6">
                <label className="form-label my-3 my-lg-3"># of Boxes:</label>
              </div>
              <div className="col-6">
                <p className="my-3 my-lg-3">{prescription_attributes && prescription_attributes.number_of_boxes ? prescription_attributes.number_of_boxes : 'N/A'}</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ShowPrescriberInformation;
